var hashtag_default = {
  "fontElementMap": "xrX8Z",
  "hashtag": "yX9P4"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
